import { BaseEntity } from 'yt-ng-framework';

export class Pol extends BaseEntity {
    constructor(){
        super();
    }
    //Naziv: string;
    Naziv: string = null;
    //datetimecr: Date;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
       // this.datetimecr = input.datetimecr;
        return this;
    }

    Serialize(input: Pol){
        return input;
    }
}
